import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';
import {
  BehaviorSubject,
  catchError,
  filter,
  Observable,
  of,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private auth: AuthService,
    private router: Router,
    private tokenExtractor: HttpXsrfTokenExtractor
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      withCredentials: true,
    });
    debugger
    request = this.addToken(request);
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (
          request.url.includes('refresh-token') ||
          request.url.includes('login')
        ) {
          if (request.url.includes('refresh-token')) {
            this.router.navigateByUrl('/auth/login');
            this.auth.logout(false);
          }
          return throwError(() => error);
        }

        if (error.status !== 401) {
          return throwError(() => error);
        }

        if (this.isRefreshing) {
          return this.refreshTokenSubject.pipe(
            filter((result) => result !== null),
            take(1),
            switchMap(() => next.handle(this.addToken(request)))
          );
        } else {
          this.isRefreshing = true;
          //this.refreshTokenSubject.next(null);

          return this.auth.refreshToken().pipe(
            switchMap((token) => {
              this.isRefreshing = false;
              //this.refreshTokenSubject.next(token);

              //return next.handle(this.addToken(request, true));
              return next.handle(this.addToken(request));
            }),
            catchError((err) => {
              this.isRefreshing = false;
              this.auth.logout(false);
              return throwError(() => err);
            })
          );
        }
      })
    );
  }

  private addToken(request: HttpRequest<any>) {
    if (!this.auth.jwtToken) return request;
    debugger
    let token = this.tokenExtractor.getToken() as string;
    if (token !== null) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.jwtToken}`,
          "X-XSRF-TOKEN": token
        },
      });
    }
    else {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.jwtToken}`
        },
      });
    }
  }
}
